import styled, { css } from 'styled-components';

const Track = styled.div`
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(
        calc(
          -${(props) => props.slideWidth}px * ${(props) => props.totalSlideNumber}
        )
      );
    }
  }
  ${(props) => props.infiniteAutoplay
    && css`
      animation: scroll
        ${({ totalSlideNumber, slideDisplayTime }) => totalSlideNumber * slideDisplayTime}ms
        linear infinite;
    `}
`;

export default Track;
